import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  kitId: string;
  spaceId: string | number;
  version: number;
};

const [useUpdateRecommendedVersion, updateRecommendedVersion] = createAsyncAction(
  "kits/updateRecommendedVersion",
  async ({ kitId, spaceId, version }: Args) => {
    const res = await API.call<{ kit: string }>({
      endpoint: `kits/${spaceId}/${kitId}`,
      method: "PUT",
      data: {
        use_version: version,
      },
    });
    return { ...res, result: res.result.kit };
  }
);
export default useUpdateRecommendedVersion;
export { updateRecommendedVersion };
